module.exports = __webpack_public_path__ + "img/ml3042.5c78d443.png";